import { isRouteErrorResponse, useRouteError, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { RefreshCw, Home } from 'lucide-react'

export default function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  const message = isRouteErrorResponse(error)
    ? error.statusText || error.data?.message
    : error instanceof Error
      ? error.message
      : undefined

  if (import.meta.env.DEV) {
    console.error('[RouteErrorBoundary]', error)
  }

  return (
    <div className='flex h-screen w-full flex-col items-center justify-center gap-4 p-6 text-center'>
      <h1 className='text-xl font-semibold'>Une erreur inattendue est survenue</h1>
      <p className='max-w-md text-sm text-muted-foreground'>
        {message || "Quelque chose s'est mal passé pendant l'affichage de cette page."}
      </p>
      <div className='flex gap-3'>
        <Button onClick={() => window.location.reload()}>
          <RefreshCw className='mr-2 h-4 w-4' />
          Recharger la page
        </Button>
        <Button variant='secondary' onClick={() => navigate('/dashboard')}>
          <Home className='mr-2 h-4 w-4' />
          Retour à l'accueil
        </Button>
      </div>
    </div>
  )
}
